import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "flex-grow flex flex-col min-h-0 gap-y-2 px-3 py-2 bg-gray-lp-200",
  style: {"height":"calc(calc(100vh / var(--viewport-scale)) - 137px)"}
}
const _hoisted_2 = { class: "flex-grow flex flex-col min-h-0 gap-y-2" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = { class: "w-1/6" }
const _hoisted_5 = { class: "flex-1 overflow-y-auto" }
const _hoisted_6 = {
  key: 2,
  class: "bg-white shadow text-sm"
}
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "sticky top-0 z-10 bg-white border-b border-t border-gray-lp-400" }, [
  /*#__PURE__*/_createVNode("table", { class: "min-w-full table-fixed" }, [
    /*#__PURE__*/_createVNode("thead", null, [
      /*#__PURE__*/_createVNode("tr", null, [
        /*#__PURE__*/_createVNode("th", { class: "px-3 py-4 text-left w-1/20" }, "No"),
        /*#__PURE__*/_createVNode("th", { class: "px-3 py-4 text-left w-3/20" }, "Kode Ursa"),
        /*#__PURE__*/_createVNode("th", { class: "px-3 py-4 text-left w-5/20" }, "3LC"),
        /*#__PURE__*/_createVNode("th", { class: "px-3 py-4 text-left w-6/20" }, "Kecamatan, Kota"),
        /*#__PURE__*/_createVNode("th", { class: "px-3 py-4 text-left w-3/20" }, "Kode POS"),
        /*#__PURE__*/_createVNode("th", { class: "px-3 py-4 text-left w-2/20" }, "Status")
      ])
    ])
  ])
], -1)
const _hoisted_8 = { class: "min-w-full table-auto" }
const _hoisted_9 = { class: "px-3 py-2 text-left w-1/20" }
const _hoisted_10 = { class: "px-3 py-2 text-left w-3/20" }
const _hoisted_11 = { class: "px-3 py-2 text-left w-5/20" }
const _hoisted_12 = { class: "px-3 py-2 text-left w-6/20" }
const _hoisted_13 = { class: "px-3 py-2 text-left w-3/20" }
const _hoisted_14 = { class: "px-3 py-2 text-left w-2/20" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Search = _resolveComponent("Search")!
  const _component_CustomDropdown = _resolveComponent("CustomDropdown")!
  const _component_EmptyState = _resolveComponent("EmptyState")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_CardPopupOtherTag = _resolveComponent("CardPopupOtherTag")!
  const _component_Card = _resolveComponent("Card")!
  const _component_PaginationV3 = _resolveComponent("PaginationV3")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Card, {
      class: "p-3 flex-grow flex flex-col min-h-0",
      rounded: "2xl"
    }, {
      default: _withCtx(() => [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode(_component_Search, {
              onInput: _ctx.onSearch,
              onClear: () => _ctx.onSearch(''),
              value: _ctx.dataTable.params.q,
              class: "w-1/3",
              placeholder: "Cari kota, kecamatan, 3LC, ursa, kode pos",
              minChar: 3,
              timeout: 500
            }, null, 8, ["onInput", "onClear", "value"]),
            _createVNode("div", _hoisted_4, [
              _createVNode(_component_CustomDropdown, {
                modelValue: _ctx.dataTable.params.status,
                "onUpdate:modelValue": [
                  _cache[1] || (_cache[1] = ($event: any) => (_ctx.dataTable.params.status = $event)),
                  _ctx.onSelectStatus
                ],
                preventUnselect: "",
                "selected-item": _ctx.dataTable.params.status,
                options: _ctx.listStatus,
                placeholder: "Semua Status"
              }, null, 8, ["modelValue", "onUpdate:modelValue", "selected-item", "options"])
            ])
          ]),
          _createVNode("div", _hoisted_5, [
            (_ctx.dataTable.error.empty)
              ? (_openBlock(), _createBlock(_component_EmptyState, {
                  key: 0,
                  customHeaderMessage: "Data belum tersedia",
                  customMessage: "Jika sudah ada data, maka akan muncul di sini secara otomatis."
                }))
              : (_ctx.dataTable.error.type)
                ? (_openBlock(), _createBlock(_component_ErrorMessage, {
                    key: 1,
                    errorType: _ctx.dataTable.error.type,
                    onTryAgain: _ctx.dataTable.error.onRetry
                  }, null, 8, ["errorType", "onTryAgain"]))
                : (_openBlock(), _createBlock("div", _hoisted_6, [
                    _hoisted_7,
                    _createVNode("table", _hoisted_8, [
                      _createVNode("tbody", null, [
                        (_ctx.dataTable.loading)
                          ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, _renderList(20, (row) => {
                              return _createVNode("tr", { key: row }, [
                                (_openBlock(), _createBlock(_Fragment, null, _renderList(6, (col) => {
                                  return _createVNode("td", {
                                    key: col,
                                    class: ["px-4 py-5", {
                        'rounded-bl-xl': col === 1 && row === 20,
                        'rounded-br-xl': col === 6 && row === 20
                      }]
                                  }, [
                                    _createVNode(_component_Skeleton, {
                                      height: "20px",
                                      width: "100%"
                                    })
                                  ], 2)
                                }), 64))
                              ])
                            }), 64))
                          : (_openBlock(true), _createBlock(_Fragment, { key: 1 }, _renderList(_ctx.dataTable.data, (item, index) => {
                              return (_openBlock(), _createBlock("tr", {
                                key: item.ursaCode,
                                class: "border-b border-gray-lp-400 hover:bg-gray-50 cursor-pointer",
                                onClick: () => _ctx.onClickRow(item)
                              }, [
                                _createVNode("td", _hoisted_9, _toDisplayString(index + 1 + _ctx.offset), 1),
                                _createVNode("td", _hoisted_10, _toDisplayString(item.ursaCode), 1),
                                _createVNode("td", _hoisted_11, [
                                  _createVNode(_component_CardPopupOtherTag, {
                                    key: `3lc-${item.ursaCode}`,
                                    list: item['3lc'],
                                    limitRender: 6,
                                    title: "3LC"
                                  }, null, 8, ["list"])
                                ]),
                                _createVNode("td", _hoisted_12, [
                                  _createVNode(_component_CardPopupOtherTag, {
                                    key: `city-${item.ursaCode}`,
                                    list: item.area,
                                    limitRender: 3,
                                    title: "Kecamatan, Kota"
                                  }, null, 8, ["list"])
                                ]),
                                _createVNode("td", _hoisted_13, [
                                  _createVNode(_component_CardPopupOtherTag, {
                                    key: `postalCode-${item.ursaCode}`,
                                    list: item.postalCode,
                                    limitRender: 5,
                                    title: "Kode POS"
                                  }, null, 8, ["list"])
                                ]),
                                _createVNode("td", _hoisted_14, [
                                  _createVNode("div", {
                                    innerHTML: _ctx.getChipsStyles(item.isActive)
                                  }, null, 8, ["innerHTML"])
                                ])
                              ], 8, ["onClick"]))
                            }), 128))
                      ])
                    ])
                  ]))
          ])
        ])
      ]),
      _: 1
    }),
    (!_ctx.dataTable.loading && _ctx.dataTable.data?.length)
      ? (_openBlock(), _createBlock(_component_Card, {
          key: 0,
          class: "px-3",
          rounded: "2xl"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_PaginationV3, {
              pagination: _ctx.dataTable.pagination,
              "onUpdate:pagination": _cache[2] || (_cache[2] = ($event: any) => (_ctx.dataTable.pagination = $event)),
              renderedData: _ctx.dataTable.data.length,
              onSetPage: _ctx.onSetPage,
              paginationPaddingVertical: "py-0"
            }, null, 8, ["pagination", "renderedData", "onSetPage"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}